export const toggleQuestionStatus=(id,fields)=>{
    return `mutation{updateQuestionStatus(id:${id}){${fields.join(" ")}}}`
}


export const createQuestionMutation=(Dto)=>{
 return `mutation{createQues(createQuesDto:{ques_text:"${Dto.title}",quiz_id:${Dto.quiz},is_active:${Dto.status}}){id is_active}}`
}



export const deleteQuestionMutatuion=(id)=>`mutation{
    deleteQuestion(id:${id}){id}
    }`

export const UpdateQuestionMutation=(id,Dto)=>`mutation{
    questionUpdate(id:${id},updateQuestionDto:{ques_text:"${Dto.title}",is_active:${Dto.status},quiz_id:${Dto.quiz_id}}){id}
 }`

